<template>
  <article :class="['card', { 'is-linked': (route), 'has-no-header': !title }]" @click="pushToRoute">
    <header class="card-header" v-if="title">
      <span class="card-header-title">{{ title }}</span>
      <slot v-if="$slots.tools" name="tools"/>
    </header>
    <div :class="['card-content', contentClass]">
      <slot/>
    </div>
    <footer class="card-footer" v-if="$slots.footer">
      <slot name="footer"/>
    </footer>
  </article>
</template>

<script>
export default {

  props: {
    title: String,
    contentClass: String,
    route: String,
  },

  methods: {
    pushToRoute() {
      if (this.route) this.$router.push({
        name: this.route
      })
    }
  }

}
</script>
